import MaskedInput from 'react-text-mask'
import React, { FC, useCallback, ChangeEventHandler } from 'react'
import { useStoreActions } from '@mortgage-pos/ui/store'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

interface Props {
  name: string
  value: string
  title?: string
  placeholder?: string
  onChange: ChangeEventHandler<HTMLInputElement>
}

const zipCodeMask = createNumberMask({
  prefix: '',
  suffix: '',
  inputMode: 'numeric',
  includeThousandsSeparator: false,
  integerLimit: 5, // limit length of integer numbers
  allowNegative: false,
  allowLeadingZeroes: true,
})

const ZipCodeFetchInput: FC<Props> = ({
  name,
  value,
  title,
  placeholder,
  onChange,
  ...rest
}) => {
  const { getStateByZip } = useStoreActions((state) => state.address)

  const handleInputChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (e) => {
      const newEvent: React.ChangeEvent<HTMLInputElement> = {
        ...e,
        target: {
          ...e.target,
          name,
          value: e.target.value,
        },
      }
      if (e.target.value.length === 5) {
        getStateByZip(e.target.value)
      }
      onChange(newEvent)
    },
    [name, onChange]
  )

  return (
    <div className="input__zipcode-wrapper">
      <MaskedInput
        mask={zipCodeMask}
        type="text"
        value={value}
        autoComplete={'off'}
        name={name}
        className="input__field --zipcode"
        onChange={handleInputChange}
        maxLength="5"
        placeholder={placeholder}
        {...rest}
      />
    </div>
  )
}

export default ZipCodeFetchInput
